module.exports = __webpack_public_path__ + "img/材料力学8_3_3.3625900d.jpg";